import * as React from 'react';

import { getShouldShowXDPAndCourseraPlusLandingPageChanges } from 'bundles/coursera-plus/utils/subscriptionsForwardDiscoveryExperiment';
import { useCourseraPlusOwnership } from 'bundles/unified-description-page-common/contexts/consumer/CourseraPlusOwnershipContext';

type Props = {
  children: React.ReactNode;
};

type Data = {
  shouldShowXdpChanges: boolean;
};

const XdpSubscriptionsForwardDiscoveryContext = React.createContext<Data>({ shouldShowXdpChanges: false });

export const useXdpSubscriptionsForwardDiscovery = () => React.useContext(XdpSubscriptionsForwardDiscoveryContext);

const DataProviderWithoutImpression = ({ children }: Props) => {
  return (
    <XdpSubscriptionsForwardDiscoveryContext.Provider
      value={{
        shouldShowXdpChanges: false,
      }}
    >
      {children}
    </XdpSubscriptionsForwardDiscoveryContext.Provider>
  );
};

const DataProviderWithImpression = ({ children }: Props) => {
  const shouldShow = getShouldShowXDPAndCourseraPlusLandingPageChanges();
  return (
    <XdpSubscriptionsForwardDiscoveryContext.Provider value={{ shouldShowXdpChanges: shouldShow ?? false }}>
      {children}
    </XdpSubscriptionsForwardDiscoveryContext.Provider>
  );
};

/**
 * We use this provider in order to only make an impression in the subscriptions forward discovery experiment
 * if the XDP is eligible for Coursera Plus
 */
const SubscriptionsForwardDiscoveryDataProvider = ({ children }: Props) => {
  const courseraPlusOwnership = useCourseraPlusOwnership();

  if (!courseraPlusOwnership?.isCourseraPlusEligibleProduct) {
    return <DataProviderWithoutImpression>{children}</DataProviderWithoutImpression>;
  }

  return <DataProviderWithImpression>{children}</DataProviderWithImpression>;
};

export default SubscriptionsForwardDiscoveryDataProvider;
